import { LitElement, html, css } from 'lit-element'


//函數


//

export default class WordCloudClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    backToHome(){
      document.getElementById('generate-img-ui').style='display: none;';
      document.getElementById('clip-front').style='display: block;';
      document.getElementById('generate-img-2-ui').style='display: none;';
      document.getElementById('prompt-template-ui').style='display: none;';
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      
      
      ul.cloud {
        list-style: none;
        padding-left: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        line-height: 2.75rem;
        width: 80%;
        height: 60%;
        margin-left: 10%;
    margin-top: 5%;
        /* width: 450px; */
      }
      
      ul.cloud a {
        /*   
        Not supported by any browser at the moment :(
        --size: attr(data-weight number); 
        */
        --size: 4;
        --color: #a33;
        color: var(--color);
        font-size: calc(var(--size) * 0.25rem + 0.5rem);
        display: block;
        padding: 0.125rem 0.25rem;
        position: relative;
        text-decoration: none;
        /* 
        For different tones of a single color
        opacity: calc((15 - (9 - var(--size))) / 15); 
        */
      }
      
      ul.cloud a[data-weight="1"] { --size: 1; }
      ul.cloud a[data-weight="2"] { --size: 2; }
      ul.cloud a[data-weight="3"] { --size: 3; }
      ul.cloud a[data-weight="4"] { --size: 4; }
      ul.cloud a[data-weight="5"] { --size: 6; }
      ul.cloud a[data-weight="6"] { --size: 8; }
      ul.cloud a[data-weight="7"] { --size: 10; }
      ul.cloud a[data-weight="8"] { --size: 13; }
      ul.cloud a[data-weight="9"] { --size: 16; }
      
      ul[data-show-value] a::after {
        content: " (" attr(data-weight) ")";
        font-size: 1rem;
      }
      
      ul.cloud li:nth-child(2n+1) a { --color: #181; }
      ul.cloud li:nth-child(3n+1) a { --color: #33a; }
      ul.cloud li:nth-child(4n+1) a { --color: #c38; }
      
      ul.cloud a:focus {
        outline: 1px dashed;
      }
      
      ul.cloud a::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 100%;
        background: var(--color);
        transform: translate(-50%, 0);
        opacity: 0.15;
        transition: width 0.25s;
      }
      
      ul.cloud a:focus::before,
      ul.cloud a:hover::before {
        width: 100%;
      }
      
      @media (prefers-reduced-motion) {
        ul.cloud * {
          transition: none !important;
        }
      }
      `
    }
    
  render () {
      return html`
      
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          
        </head>
        <body>
        <ul class="cloud" role="navigation" aria-label="Webdev word cloud">
            <li><a href="#" data-weight="4">Space</a></li>
            <li><a href="#" data-weight="1">Environments</a></li>
            <li><a href="#" data-weight="5">Cute</a></li>
            <li><a href="#" data-weight="8">Clay</a></li>
            <li><a href="#" data-weight="6">Accessory</a></li>
            <li><a href="#" data-weight="4">Toys</a></li>
            <li><a href="#" data-weight="5">Games</a></li>
            <li><a href="#" data-weight="6">Typography</a></li>
            <li><a href="#" data-weight="2">Cartoon</a></li>
            <li><a href="#" data-weight="9">Photograph</a></li>
            <li><a href="#" data-weight="3">Concept Art</a></li>
            <li><a href="#" data-weight="7">Funny</a></li>
            <li><a href="#" data-weight="8">Planets</a></li>
            <li><a href="#" data-weight="1">Science Fiction</a></li>
            <li><a href="#" data-weight="3">Celebrity</a></li>
            <li><a href="#" data-weight="3">Patterns</a></li>
            <li><a href="#" data-weight="7">Landscapes</a></li>
            <li><a href="#" data-weight="8">Sketch</a></li>
            <li><a href="#" data-weight="1">Portraits</a></li>
            <li><a href="#" data-weight="3">People</a></li>
            <li><a href="#" data-weight="4">Wallpaper</a></li>
            <li><a href="#" data-weight="1">Sprites</a></li>
            <li><a href="#" data-weight="5">Logos</a></li>
            <li><a href="#" data-weight="8">Product Design</a></li>
            <li><a href="#" data-weight="6">Avatars</a></li>
            <li><a href="#" data-weight="4">Psychedelic</a></li>
            <li><a href="#" data-weight="5">Drawing</a></li>
            <li><a href="#" data-weight="6">Plants</a></li>
          </ul>
    </body>
</html>
      

      `
  }
  
}
